const playoffWeekNames = [{ weekNumber: 19, weekName: 'Wild Card Weekend' }, { weekNumber: 20, weekName: 'the Divisional Round' }, { weekNumber: 21, weekName: 'the Conference Championships' }, { weekNumber: 22, weekName: 'the Superbowl' }];

export default playoffWeekNames;